import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'api/models';
import { UsersStore } from './store';

export const usersSlice = createSlice({
  name: '@@USERS',
  initialState: UsersStore.empty(),
  reducers: {
    load: (state: UsersStore) => UsersStore.load()(state),
    putAll: (state: UsersStore, { payload: users }: PayloadAction<User[]>) =>
      UsersStore.putAll(users)(),
    added: (state: UsersStore, { payload: user }: PayloadAction<User>) =>
      UsersStore.added(user)(state),
    addedAll: (state: UsersStore, { payload: users }: PayloadAction<User[]>) =>
      UsersStore.addedAll(users)(state),
    updating: (state: UsersStore, { payload: user }: PayloadAction<User>) =>
      UsersStore.updating(user)(state),
    updated: (state: UsersStore, { payload: user }: PayloadAction<User>) =>
      UsersStore.updated(user)(state),
    revert: (state: UsersStore, { payload: userId }: PayloadAction<number>) =>
      UsersStore.reverted(userId)(state),
    deleting: (state: UsersStore, { payload: user }: PayloadAction<User>) =>
      UsersStore.deleting(user)(state),
    deleted: (
      state: UsersStore,
      { payload: user }: PayloadAction<Pick<User, 'userId'>>,
    ) => UsersStore.deleted(user)(state),
  },
});
